import setPaymentMethod from './setPaymentMethod';

const LocalAPI = {
  setPaymentMethod,
};

export default LocalAPI;
